import { userFormData } from './api';
import React, { Component } from 'react';

import { ErrorMessage } from '../ErrorMessage';
import { Loader } from '../Loader';
import UserRoles from './UserRoles';
import { Query } from '@apollo/client/react/components';
import UserInformation from './UserInformation';
import { Form, Button } from 'react-bootstrap';

class UserForm extends Component {
  // default user state
  state = {
    user: {
      name: '',
      email: '',
      adId: '',
      active: false,
      sendEmail: false,
      mailStop: '',
    },
    roles: [],
    defaultRole: {
      departmentId: -1,
      roleId: -1,
    },
  };

  formType = {
    create: 1,
    update: 2,
  };

  formActions = {
    setName: (name) => this.setState({ user: { ...this.state.user, name } }),
    setAdId: (adId) => this.setState({ user: { ...this.state.user, adId } }),
    setEmail: (email) => this.setState({ user: { ...this.state.user, email } }),
    setMailStop: (mailStop) => this.setState({ user: { ...this.state.user, mailStop } }),
    setActive: (active) => this.setState({ user: { ...this.state.user, active: !this.state.user.active } }),
    setSendEmail: (sendEmail) => this.setState({ user: { ...this.state.user, sendEmail: !this.state.user.sendEmail } }),
  };

  addRole = (role) => {
    this.setState({
      roles: [
        ...this.state.roles,
        {
          roleId: role.id,
          roleType: role.roleType,
        },
      ],
    });
  };

  removeRole = (role) => {
    if (this.state.defaultRole.roleId === role.id) {
      this.setState({
        roles: this.state.roles.filter((currentRole) => role.id !== currentRole.roleId),
        defaultRole: {
          departmentId: -1,
          roleId: -1,
        },
      });
    }
    this.setState({
      roles: this.state.roles.filter((currentRole) => role.id !== currentRole.roleId),
    });
  };

  addDepartments = (roleId, departments, departmentIdForDefaultRole) => {
    let roles = this.state.roles.map((role) => {
      if (role.roleId === roleId) {
        role.departments = departments;
      }
      return role;
    });

    if (departmentIdForDefaultRole !== -1) {
      let defaultRole = {
        departmentId: departmentIdForDefaultRole,
        roleId,
      };
      this.setState({ roles, defaultRole });
    }

    this.setState({ roles });
  };

  componentDidMount() {
    if (this.props.type === this.formType.update) {
      let roles = this.props.user.applicationUserRoles.reduce((acc, currentAppRole) => {
        let indexOfRole = acc.findIndex((role) => role.roleId === currentAppRole.role.id);
        if (indexOfRole >= 0) {
          acc[indexOfRole].departments.push(currentAppRole.department);
        } else {
          acc.push({
            roleId: currentAppRole.role.id,
            Name: currentAppRole.role.roleType,
            departments: [currentAppRole.department],
          });
        }

        return acc;
      }, []);

      let defaultRole = this.props.user.applicationUserRoles.find((currentRole) => currentRole.isDefaultRole);

      this.setState({
        user: {
          id: this.props.user.id,
          name: this.props.user.name,
          email: this.props.user.emailAddress,
          adId: this.props.user.adId,
          active: this.props.user.active,
          sendEmail: this.props.user.sendEmail,
          mailStop: this.props.user.mailStop,
        },
        roles,
        defaultRole: defaultRole
          ? {
              departmentId: defaultRole.department.id,
              roleId: defaultRole.role.id,
            }
          : {
              departmentId: -1,
              roleId: -1,
            },
      });
    }
  }

  render() {
    return (
      <Query query={userFormData}>
        {({ loading, error, data }) => {
          if (loading) return <Loader />;
          if (error) {
            return <ErrorMessage title='Error loading user form.' />;
          }

          return (
            <div className='m-5'>
              <h3>{this.props.title}</h3>
              <Form>
                <UserInformation
                  formData={this.state.user}
                  formActions={this.formActions}
                  isNewUser={this.props.type === this.formType.create ? true : false}
                />
                <UserRoles
                  roles={data.roles}
                  addRole={this.addRole}
                  removeRole={this.removeRole}
                  departments={data.departments}
                  selectedRoles={this.state.roles}
                  addDepartments={this.addDepartments}
                  defaultRole={this.state.defaultRole}
                />
                <Button variant='success' className='mt-3' onMouseUp={() => this.props.leftAction(this.state)}>
                  {this.props.leftText}
                </Button>
                {/* <Button variant="warning" className="mt-3 float-right" onMouseUp={() => this.props.rightAction()}>
                                    {this.props.rightText}
                                </Button> */}
                {this.props.rightAction}
              </Form>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default UserForm;
